import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "./auth/react-auth0-spa";
import auth0Config from "./config/auth0Config";
import history from "./utils/history";
import ErrorBoundary from "./boundaries/ErrorBoundary";
import { ThemeProvider } from "styled-components";
import mintTheme from "carbon-react/lib/style/themes/mint";
import appRoutes from "./components/Navigation/appRoutes";

import "./index.css";

// A function that routes the user to the right place
// after login
const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};

const onAuthError = (error) => {
  console.log(error);
  history.push(appRoutes.error);
};

const resolveNamedConnection = (connection) => {
  return connection && typeof connection === "string" && connection.length > 0
    ? connection
    : undefined;
};

ReactDOM.render(
  <Auth0Provider
    domain={auth0Config.domain}
    client_id={auth0Config.clientId}
    audience={auth0Config.audience}
    scope={auth0Config.scopes}
    connection={resolveNamedConnection(auth0Config?.connection)}
    federatedLogout={auth0Config?.federatedLogout}
    redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    onError={onAuthError}
  >
    <ErrorBoundary redirectTo={appRoutes.error}>
      <ThemeProvider theme={mintTheme}>
        <App />
      </ThemeProvider>
    </ErrorBoundary>
  </Auth0Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
